import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { signOut } from 'aws-amplify/auth';
import { BehaviorSubject } from 'rxjs';
import { AuthNewService } from '../../../service/auth-new.service';

@Component({
    selector: 'app-user-sign-in',
    templateUrl: './user-sign-in.component.html',
    styleUrls: ['./user-sign-in.component.scss'],
    standalone: false
})
export class UserSignInComponent implements OnInit {

  signinForm!: FormGroup;
  codeForm!: FormGroup;
  submitted = false;
  username!: string;
  password!: string;
  code!: string;
  user!: CognitoUser;
  userAuthenticated = false;
  mfaFlag = false;
  userGroup = new BehaviorSubject<string>('');
  hide = true;
  resetMessage: string = "";
  error

  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private authservice: AuthNewService
  ) { }

  ngOnInit(): void {
    signOut().then(res => {
      // console.log("Signed out");
    })
    this.route.queryParamMap.subscribe((params) => {
      if (params.get('reset') === "success") {
        this.resetMessage = "Your password has been successfully reset!"
      }
    })
    this.signinForm  =  this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.codeForm  =  this.formBuilder.group({
      code: ['', Validators.required]
    });
  }
  get formControls() { return this.signinForm.controls; }
  get formControls1() { return this.codeForm.controls; }

  signInNew() {
    this.submitted = true;
    this.userAuthenticated = false;
    if (this.signinForm.invalid) {
      return;
    }
    // console.log(JSON.stringify(this.signinForm.value, null, 2));
    this.username = this.signinForm.value.username;
    this.password = this.signinForm.value.password;
    this.authservice.handleSignIn(this.username, this.password).then(result => {
      if (result.Status === "MFA") {
        this.mfaFlag = true;
      } else if (result.Status === "NEW_PASSWORD") {
        this.router.navigate(['/extra-layout/new-password']);
      } else if (result.Status === "SUCCESS") {
        if (sessionStorage.getItem('access') == 'QA') {
          this.router.navigate(['default-layout/audit-trail']);
        } else {
          this.router.navigate(['default-layout/previous-analysis']);
        }
      } else {
        // console.log("Login attempt return status:");
        // console.log(result.Status);
        this.submitted = false;
        this.error = 'Username or password is incorrect';
      }
    });
  }

  confirmationCode() {
    this.code = this.codeForm.value.code;
    this.authservice.handleConfirmCode(this.code).then(data => {
      if (data.isSignedIn) {
        this.router.navigate(['default-layout/previous-analysis']);
      }
    }).catch(error => {
//       console.log(error);
    });
  }
}
